module.exports = __webpack_public_path__ + "img/手机端商品.d61c2f6c.png";